import {
  AlertBannerType,
  ButtonFlavor, ButtonSize, ButtonType, ExAlertBanner, ExButton, ExDialog,
} from '@boomi/exosphere';
import { useTranslation } from 'react-i18next';
import { AppConstants } from '@common';

type WarningMessageProps = {
  open: boolean;
  onDialogClose: () => void;
};

function TimeOutOfSyncWarningMessage({
  open, onDialogClose,
}: WarningMessageProps) {
  const [t] = useTranslation('common');
  return (
    <ExDialog open={open} dialogTitle={AppConstants.EMPTY_STRING} onCancel={onDialogClose} staticBackdrop hideClose data-testid="timeout-warning-dialog-box">
      <div className="timeout__message">
        <ExAlertBanner type={AlertBannerType.WARNING} open>
          {t('application_clock_drift_exceeds_threshold')}
        </ExAlertBanner>
      </div>
      <ExButton
        slot="footer"
        flavor={ButtonFlavor.BASE}
        type={ButtonType.SECONDARY}
        size={ButtonSize.LARGE}
        onClick={onDialogClose}
      >
        {t('close')}
      </ExButton>
    </ExDialog>
  );
}

export default TimeOutOfSyncWarningMessage;
